import { z } from "zod";
import { groupBy } from "../../utils";

export const DesignElementSnapshotReason = z.enum(["Publish", "Deletion"]);

export const DesignElementSnapshotBase = z.object({
  id: z.string(),
  persistentId: z.string(),
  designSystemVersionId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  reason: DesignElementSnapshotReason,
  createdByUserId: z.string(),
});

export type DesignElementSnapshotBase = z.infer<typeof DesignElementSnapshotBase>;
export type DesignElementSnapshotReason = z.infer<typeof DesignElementSnapshotReason>;

//
// Util functions
//

export function pickLatestSnapshots<T extends DesignElementSnapshotBase>(
  snapshots: T[],
  getSnapshotElementId: (snapshot: T) => string
): T[] {
  const groupedSnapshots = groupBy(snapshots, getSnapshotElementId);

  return Array.from(groupedSnapshots.entries()).map(([_, snapshots]) => {
    // Sort snapshots by created at date desc
    const sorted = snapshots.sort((lhs, rhs) => rhs.createdAt.getTime() - lhs.createdAt.getTime());
    return sorted[0];
  });
}
